import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { decorateWith, withName } from 'helpers/decorator';
import { hideModal } from 'redux/modules/modals';
import { Link } from '../Link';

export class CloseModalUnwrapped extends PureComponent {
  constructor(props) {
    super(props);
    this.handleOnClick = this.handleOnClick.bind(this);
  }

  handleOnClick() {
    const { closeModal } = this.props;
    closeModal('OfferModal');
  }

  render() {
    const { children, closeModal, to, ...extraProps } = this.props;

    return to ? (
      <Link onClick={this.handleOnClick} to={to} {...extraProps}>
        {children}
      </Link>
    ) : (
      <button className="link--btn" onClick={this.handleOnClick}>
        {children}
      </button>
    );
  }
}

CloseModalUnwrapped.propTypes = {
  children: PropTypes.node.isRequired,
  closeModal: PropTypes.func.isRequired,
  to: PropTypes.string,
};

export const mapDispatchToProps = {
  closeModal: hideModal,
};

export const CloseModal = decorateWith(connect(null, mapDispatchToProps), withName('CloseModal'))(CloseModalUnwrapped);
